// ============================================================
// CUSTOS XIIBERO Portal — MSAL Authentication Config
// Tenant:   custosxiiberoportal.onmicrosoft.com (Entra External ID)
// Frontend: e4db1b3e-dd4c-4cca-bfc3-d2d92b5c72af
// API:      dd2120e3-5bc0-4669-b45c-89b27deae8e7
// ============================================================

export const msalConfig = {
  auth: {
    clientId:    "e4db1b3e-dd4c-4cca-bfc3-d2d92b5c72af",
    authority:   "https://custosxiiberoportal.ciamlogin.com",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation:        "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (process.env.NODE_ENV === "development") console.log(`[MSAL] ${message}`);
      },
    },
  },
};

// Scopes for the API
export const apiScopes = [
  "api://dd2120e3-5bc0-4669-b45c-89b27deae8e7/dashboard.read",
];

// Login request
export const loginRequest = {
  scopes: ["openid", "profile", "email", ...apiScopes],
};

// Silent token request
export const tokenRequest = {
  scopes: apiScopes,
};
